import { useMutation } from 'convex/react';
import { api } from 'convex/_generated/api';

export function useDeleteGarden() {
  return useMutation(api.gardens.mutations.deleteGarden).withOptimisticUpdate(
    (localStore, { gardenId }) => {
      const current = localStore.getQuery(api.gardens.queries.getUserGardens, {});
      if (current === undefined) return;

      localStore.setQuery(
        api.gardens.queries.getUserGardens,
        {},
        current.filter((g) => g._id !== gardenId)
      );
    }
  );
}
